<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="amzFirstDemandCode"
      border
      auto-resize
      highlight-hover-row
      resizable
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:amzFlipOrderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFlipOrderStatus == 'N'
              ? 'info'
              : row.amzFlipOrderStatus == 'S'
              ? ''
              : row.amzFlipOrderStatus == 'P'
              ? 'success'
              : row.amzFlipOrderStatus == 'R'
              ? 'danger'
              : row.amzFlipOrderStatus == 'D'
              ? 'danger'
              : row.amzFlipOrderStatus == 'T'
              ? ''
              : row.amzFlipOrderStatus == 'A'
              ? 'success'
              : row.amzFlipOrderStatus == 'B'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_amzFlipOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:amzFtyPurchaseStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFtyPurchaseStatus == 'A'
              ? 'success'
              : row.amzFtyPurchaseStatus == 'B'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_amzFtyPurchaseStatus }}
        </el-tag>
      </template>
      <template v-slot:skuSalesChannel="{ row }">
        <el-tag
          size="mini"
          v-if="row.v_skuSalesChannel"
          :type="row.skuSalesChannel == 'V' ? 'warning' : ''"
        >
          {{ row.v_skuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
